import { render, staticRenderFns } from "./NewLeadsWidget.vue?vue&type=template&id=6fbfd948&scoped=true&lang=pug"
import script from "./NewLeadsWidget.vue?vue&type=script&lang=js"
export * from "./NewLeadsWidget.vue?vue&type=script&lang=js"
import style0 from "./NewLeadsWidget.vue?vue&type=style&index=0&id=6fbfd948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbfd948",
  null
  
)

export default component.exports